import React, { ForwardedRef } from 'react';

import './_input.scss';

interface InputComponentProps {
  value?: string;
  type?: string;
  left?: React.ReactNode;
  right?: React.ReactNode;
  placeholder?: string;
  required?: boolean;
  label?: string | React.ReactElement;
  setValue?: (value: string, fieldName?: string | null) => void;
  error?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
  readOnly?: boolean;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onClick?: React.MouseEventHandler<HTMLInputElement>;
  size?: 'normal' | 'large';
  fieldName?: string | null;
  style?: React.CSSProperties;
  focusStyle?: boolean;
  labelRight?: React.ReactNode;
  inputStyle?: React.CSSProperties;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  inputWrapperStyle?: React.CSSProperties;
  inputClassName?: string;
  inputWrapperClass?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  labelStyle?: React.CSSProperties;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  containerClassName?: string;
}

const InputComponent = (
  {
    value,
    type = 'text',
    left,
    right,
    placeholder,
    required,
    label,
    setValue = () => {},
    error,
    disabled,
    autoFocus,
    onFocus,
    readOnly = false,
    onBlur,
    onClick,
    size = 'normal',
    fieldName = null,
    style,
    focusStyle = true,
    labelRight,
    inputStyle,
    inputProps,
    inputWrapperStyle,
    inputClassName,
    inputWrapperClass,
    onChange,
    labelStyle,
    onKeyDown,
    containerClassName,
  }: InputComponentProps,
  ref: ForwardedRef<HTMLInputElement>
) => {
  return (
    <div
      style={style}
      className={`custom-input-container ${size === 'large' ? 'custom-input-container-large' : ''}  ${containerClassName}`}>
      {label && (
        <label className="custom-input-label" style={labelStyle}>
          {label}
          {required && <span className="custom-input-required">*</span>}
          {labelRight}
        </label>
      )}
      <div
        style={{ ...inputWrapperStyle, border: error && '1px solid var(--red)' }}
        className={`custom-input-wrapper ${focusStyle ? 'custom-input-wrapper-focus' : ''} ${
          size === 'large' ? 'wrapper-large' : ''
        } ${disabled ? 'bg-disabled' : ''} ${inputWrapperClass}`}>
        {left}
        <input
          {...inputProps}
          readOnly={readOnly}
          onKeyDown={onKeyDown}
          onBlur={onBlur}
          disabled={disabled}
          className={inputClassName}
          type={type}
          placeholder={placeholder}
          value={value}
          onClick={onClick}
          onChange={(e) => {
            onChange?.(e);
            if (setValue) {
              fieldName ? setValue(e.target.value, fieldName) : setValue(e.target.value);
            }
          }}
          autoFocus={autoFocus}
          onFocus={onFocus}
          style={inputStyle}
          ref={ref}
        />
        {right}
      </div>
      {error && (
        <div className={size === 'large' ? 'custom-input-error-msg-large' : 'custom-input-error-msg'}>{error}</div>
      )}
    </div>
  );
};

export default React.forwardRef(InputComponent);
